function getFileExtensionFromUrl(url) {
    try {
        if (!url) {
            return null;
        }
        
        // Remove query parameters (everything after ?)
        const urlWithoutQuery = url.split('?')[0];
        
        // Extract filename from URL
        let filename = urlWithoutQuery.substring(urlWithoutQuery.lastIndexOf('/') + 1);

        // Check if filename contains a dot
        if (filename.indexOf('.') !== -1) {
            // Extract extension from filename
            let extension = filename.split('.').pop();
            return extension.toLowerCase();
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error extracting file extension:', error.message);
        return null;
    }
}
export {
    getFileExtensionFromUrl
}